const getCognitoCallbackUrl = () => {
  if (window.location.hostname.startsWith(process.env.REACT_APP_LOCAL_ENV)) {
    return process.env.REACT_APP_LOCAL_CPMT_COGNITO_CALLBACK_URL;
  }
  if (window.location.hostname.startsWith(process.env.REACT_APP_DEV_ENV)) {
    return process.env.REACT_APP_DEV_CPMT_COGNITO_CALLBACK_URL;
  }
  if (window.location.hostname.startsWith(process.env.REACT_APP_TEST_ENV)) {
    return process.env.REACT_APP_TEST_CPMT_COGNITO_CALLBACK_URL;
  }
  return process.env.REACT_APP_PROD_CPMT_COGNITO_CALLBACK_URL;
};
export default getCognitoCallbackUrl;
